<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Send {{ workerFirstName }} ({{ workerEmail }}) the following induction reminder:</h4>
    <button type="button" class="icon" (click)="dismiss()">
      <span class="pi pi-times"></span>
    </button>
  </div>

  <div class="email-preview border border-dark rounded p-4">
    <p class="font-weight-bold">Skylark Control - Reminder Complete Site Induction</p>

    <p class="mb-3">Dear {{ workerFirstName }}</p>

    <div class="form-group">
      <input
        type="text"
        class="form-control border border-dark"
        [formControl]="messageControl"
        style="border-width: 2px; background-color: #f8fbff; border-radius: 0;"
        #reminderMessageInput
      />
      <div *ngIf="messageControl.invalid && messageControl.touched" class="text-danger mt-1">Message is required.</div>
    </div>

    <p class="mt-4 mb-1">Not completing this course prevents access to the following site(s):</p>
    <ul class="mb-3">
      <li>{{ siteName }}</li>
      <li>...</li>
    </ul>
    <p>Please take this course again as soon as possible to ensure continued access to these sites.</p>
    <p><span class="text-primary" style="text-decoration: underline;">Take Skylark Induction</span></p>
    <p>Regards</p>
    <p>Skylark Control</p>
  </div>

  <div class="modal-footer justify-content-center">
    <button type="button" class="my-2 btn btn-round btn-sm btn-outline-secondary" (click)="dismiss()" [disabled]="isSending">
      Cancel
    </button>
    <button
      type="button"
      class="my-2 btn btn-round btn-sm btn-primary"
      (click)="submit()"
      [disabled]="messageControl.invalid || isSending"
    >
      <ng-container *ngIf="isSending">
        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        Sending...
      </ng-container>
      <ng-container *ngIf="!isSending">
        Send reminder
      </ng-container>
    </button>
  </div>
</div>
